// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"_11COC","leftArrowButton":"ab5tH","icon":"SyGgr","rightArrowButton":"_3lgfJ"};